"use client";
import { RtlProvider } from "@/providers/RtlProvider";

export default function Providers({ children }) {
  return <RtlProvider>{children}</RtlProvider>;
}
